<template>
  <div>
    <popup-add-dynamic-form ref="popupAddDynamicForm" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Dynamic forms</h3>
        <p class="mt-5">
          Dynamic forms can be embedded on any website and show forms such as
          campaigns, newsletter forms and so on.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            v-if="$AuthService.hasPermission('vp.crm.dynamicforms.edit')"
            @click="$refs.popupAddDynamicForm.show()"
            type="relief"
            color="primary"
            >New form</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        search
        max-items="50"
        :data="forms"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Title</vs-th>
          <vs-th>Category</vs-th>
          <vs-th>Open type</vs-th>
          <vs-th>Enabled on</vs-th>
          <vs-th>Time constrained</vs-th>
          <vs-th>Enabled</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-category">
                  {{ tr.title }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="warning" class="product-order-status">
                  {{ tr.category || "No category" }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.openType }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.venues.length }} venues
                </vs-chip>
              </vs-td>

              <vs-td>
                <p class="status-category">
                  <vs-chip
                    :color="tr.enabled | yesnocolor"
                    class="status-circle"
                  ></vs-chip>
                  {{ tr.isTimeConstrained | yesno }}
                </p>
              </vs-td>
              <vs-td>
                <p class="status-category">
                  <vs-chip
                    :color="tr.enabled | yesnocolor"
                    class="status-circle"
                  ></vs-chip>
                  {{ tr.enabled | yesno }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupAddDynamicForm from "./PopupAddDynamicForm.vue";
export default {
  components: { PopupAddDynamicForm },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    onClicked(id) {
      this.$router
        .push({
          name: "crm-dynamicform",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Form lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      forms: "dynamicForms/dynamicForms",
      openTypes: "dynamicForms/formOpenTypes",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("dynamicForms/getAll");
    this.$vs.loading.close();
  },
};
</script>